import { Text } from "@mantine/core";

interface PendingReportAttachmentNoticeProps {
  isFinalized: boolean;
  includeInReport: boolean;
  finalizedInReport: boolean;
  subject?: "document" | "photo";
}

export function PendingReportAttachmentNotice({
  isFinalized,
  includeInReport,
  finalizedInReport,
  subject = "document",
}: PendingReportAttachmentNoticeProps) {
  if (!isFinalized || !includeInReport || finalizedInReport) return null;

  return (
    <Text size="xs" c="dimmed" role="status">
      This {subject} is selected for the next reviewed report version. View
      Report shows the current signed version until an addendum, amendment, or
      correction is reviewed and signed.
    </Text>
  );
}
